export const cactusCache = (param: string, buildId: string) => {
  return `
!(function (t, f, a, x) {
  if (!document.getElementById(x)) {
    t.async = 1;
    t.defer = true;
    t.src = a;
    t.id = x;
    f.parentNode.insertBefore(t, f);
    t.dataset.build = "${buildId}";
    t.dataset.app = "${param}";
  }
})(
  document.createElement("script"),
  document.getElementsByTagName("script")[0],
  "https://statics.cactusgaming.net/init.js?v=1&b=${buildId}&p=${param}&c="+(new Date*1),
  "cac-cache-js"
);
`;
};
